
import { BASE_URL } from "../../global";
import axiosWithToken from "./axiosTokenConfig";

export const fetchQuery = async (Condition) => {
  const response = await axiosWithToken.post(BASE_URL + 'dynamic', {query:Condition});
  return response.data || [];
};

export const fetchByTable = async (tableName,Condition) => {
let tablewithCondition = tableName + Condition;
  const response = await axiosWithToken.get(BASE_URL + tablewithCondition);
  return response.data.list.length > 0 ? response.data.list : [];
};

export const fetchCountOfTable = async (tableName,Condition) => {
let tableWithCondition = Condition ? tableName + Condition : tableName;
  const response = await axiosWithToken.get(BASE_URL + tableWithCondition);
  return response.data? response.data?.[0]?.no_of_rows : {};
};

export const fetchAddresses = async (addressIds, shippingAddressIds) => {

  let allIDS = `${addressIds},${shippingAddressIds}`;
  const containsNonText = /[a-zA-Z]/.test(allIDS);

  if (containsNonText) {
    return [];
  }
  const parseIds = (ids) => ids.split(",").map(Number);
  const sqlQuery = {
    query: `SELECT * FROM addresses WHERE id IN (${
      parseIds(addressIds).join(",") || 0
    }, ${parseIds(shippingAddressIds).join(",") || 0})`,
  };

  try {
    const addressesResponse = await axiosWithToken.post(
      BASE_URL + `dynamic`,
      sqlQuery
    );
    const addresses = addressesResponse.data;

    const billingAddressArray = parseIds(addressIds);
    const shippingAddressArray = parseIds(shippingAddressIds);

    const result = billingAddressArray.map((id, index) => {
      const address = addresses.find((a) => a.id === id);
      const shippingId = shippingAddressArray[index];
      const shippingInfo = addresses.find((a) => a.id === shippingId);

      const addressId = address ? address.id : null;
      const addressAddress = address ? address.address : "";

      return {
        id: addressId,
        address: addressAddress,
        shipping: shippingInfo
          ? { id: shippingInfo.id, address: shippingInfo.address }
          : { id: null, address: "" },
      };
    });

    return result;
  } catch (error) {
    console.error("Error fetching addresses:", error);
    return []; 
  }
};


export  function cleanValue(value) {
  if (value === null || value === undefined) return "";
  // Convert numbers to string
  if (typeof value === "number") {
    return value.toString();
  }
  if (typeof value !== "string") {
    return "";
  }
  const trimmed = value.trim();
  if (!trimmed) return "";
  return trimmed.replace(/\t/g, " ");
}

